import React, { useState, useEffect } from "react";
import './../table.css';
import { formatDate, getFinancialDateRange, groupByClinics } from "../utils";
import { useMemo } from "react";
export default (({ referralData,formData }) => {
    
    const [clinicsData, setClinicsData] = useState([]);
    useEffect(() => {
        setClinicsData(referralData?.clinicData?.clinicsData || []);
    }, [referralData]);
    // const clinicsData = groupByClinics(referralData);

    const today = useMemo(()=>formatDate(formData?.today),[formData?.today])
    return <>
        <div className="p-1 mt-6 rounded  is-drop-when-no-space" style={{ background: '#f1f4f9' }}>
            <table className="table table-bordered  table_wrap bg-white shadow table_border remove_strap">
                <thead data-color="#28a745" className="custom-header2">
                    <tr>
                        <th>Period</th>
                        <th>
                             {formData._fromDate}<br />
                            - <br /> {formData._toDate}
                        </th>
                        <th colSpan={4}>{getFinancialDateRange(formData.financialYearRange)}</th>
                    </tr>
                    <tr>
                        <th className="break-line">Practice Name</th>
                        <th className="break-line">Total Onboarded</th>
                        <th className="break-line">Account Created</th>
                        <th className="break-line">Referred Source (SMS)</th>
                        <th className="break-line">Referred Source (WhatsApp)</th>
                        <th className="break-line">Referred Source (Others)</th>
                    </tr>
                </thead>
                <tbody>
                    {clinicsData.map((item, index) => (
                        <tr key={`divison_table_${index}`}>
                            <th className="break-line">
                                {item.clinicName}
                            </th>
                            <td>{item.onboard||0}</td>
                            <td>{item.count}</td>
                            <td>{item?.sms || 0}</td>
                            <td>{item?.whatsapp || 0}</td>
                            <td>{item?.other || 0}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </>
});